import { updateDiagramZoomToFit, getDiagramZoomToFit } from '@process-advisor/process-miner/processMiner/processMiner';

export type ZoomToFitProps = {
    visible?: boolean;
}

export const changeZoomToFit = ({
    visible,
}: ZoomToFitProps) => updateDiagramZoomToFit({
    visible,
});

export const getZoomToFit = (): ZoomToFitProps => getDiagramZoomToFit();
